import { isStringNotBlank } from 'utils/utils';

const srcUrl = import.meta.url;

const isAbsoluteUrl = (urlString?: string) =>
  urlString?.indexOf('http://') === 0 || urlString?.indexOf('https://') === 0;

/**
 * If the application is loaded through a module federated component, the frontend controller url is returned.
 * Else an empty string is returned, since in those cases we want to load resources from the same origin.
 */
export const getHostBaseUrl = () => {
  const hostBaseUrl = isStringNotBlank(srcUrl) && isAbsoluteUrl(srcUrl) ? new URL(srcUrl).origin : '';
  const originUrl = window.location.origin;
  return hostBaseUrl === originUrl ? '' : hostBaseUrl;
};
